export default __webpack_public_path__ + "static/media/save-icn.1f901248.svg";